var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component logo",class:{verticalCenter: _vm.verticalCenter},style:({width: _vm.width+'px' })},[_c('div',{staticClass:"relative-height"})])}
var staticRenderFns = []

export { render, staticRenderFns }